module.exports = __webpack_public_path__ + "img/aeroland-digital-store-product-03.7287cef7.jpg";